import React from "react";
import { graphql } from "gatsby"; // to query for image data
import IndexPage from "../components/IndexPage";

export default ({ location }) => <IndexPage location={location} />;
